export default {"src":"/_next/static/media/Nopointjustskimming-0001.c77221bd.svg","height":585,"width":850,"blurWidth":0,"blurHeight":0};